import { Shield, Award, Heart, Sparkles } from 'lucide-react';

const features = [
  {
    icon: Shield,
    title: 'Garancija kvaliteta',
    description: 'Svi naši proizvodi dolaze sa punom garancijom'
  },
  {
    icon: Award,
    title: 'Nagrađivani dizajn',
    description: 'Prepoznati smo za inovativan pristup i besprekoran estetski izgled'
  },
  {
    icon: Heart,
    title: 'Ručna izrada',
    description: 'Svaki komad nameštaja je pažljivo izrađen od strane iskusnih majstora'
  },
  {
    icon: Sparkles,
    title: 'Ekološki materijali',
    description: 'Koristimo samo održive materijale koji su prijateljski prema prirodi'
  }
];

export default function About() {
  return (
    <section id="about" className="py-20 lg:py-28 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-background" />

        <div className="absolute top-20 left-0 w-[400px] h-[400px] opacity-10">
          <img 
            src="https://images.unsplash.com/photo-1680503146476-abb8c752e1f4?q=80&w=800" 
            alt=""
            className="w-full h-full object-cover rounded-3xl"
            style={{ filter: 'blur(20px)' }}
          />
        </div>
        
        <div className="absolute bottom-10 right-0 w-[380px] h-[380px] opacity-8">
          <img 
            src="https://images.unsplash.com/photo-1634712282287-14ed57b9cc89?q=80&w=800" 
            alt=""
            className="w-full h-full object-cover rounded-3xl"
            style={{ filter: 'blur(22px)' }}
          />
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Column - Text Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-foreground mb-6 lg:mb-8">
                Kvalitet koji traje generacijama
              </h2>
              <div className="space-y-5 text-base lg:text-lg text-muted-foreground leading-relaxed">
                <p>
                  Već više od 25 godina stvaramo nameštaj koji nije samo funkcionalan, već predstavlja pravo umetničko delo za vaš dom. Naša misija je da svakom prostoru donesemo toplinu, eleganciju i neponovljiv stil.
                </p>
                <p>
                  Verujemo da kvalitetni nameštaj nije luksuz, već investicija u vaš životni prostor. Zato biramo materijale najvišeg kvaliteta i radimo sa najboljim zanatlijama kako bismo stvorili komade koji će vas služiti decenijama.
                </p>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-8 pt-8 border-t border-border/40">
              <div className="space-y-2">
                <div className="text-4xl lg:text-5xl font-bold text-primary">500+</div>
                <div className="text-sm lg:text-base text-muted-foreground">Realizovanih projekata</div>
              </div>
              <div className="space-y-2">
                <div className="text-4xl lg:text-5xl font-bold text-primary">98%</div>
                <div className="text-sm lg:text-base text-muted-foreground">Zadovoljnih kupaca</div>
              </div>
            </div>
          </div>

          {/* Right Column - Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="bg-card/90 backdrop-blur-sm p-6 lg:p-8 rounded-xl border-2 border-border/50 hover:border-primary/30 transition-all duration-300 hover-shadow card-shadow group"
                  style={{
                    animationDelay: `${index * 100}ms`,
                    animation: 'fadeInScale 0.6s ease-out forwards',
                    opacity: 0
                  }}
                >
                  <div className="w-14 h-14 bg-primary/5 rounded-xl flex items-center justify-center mb-5 group-hover:bg-primary/10 transition-colors border-2 border-primary/10 group-hover:border-primary/20">
                    <Icon className="w-7 h-7 text-primary" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-lg lg:text-xl font-bold text-foreground mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm lg:text-base text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </section>
  );
}
